import { Box, Stack, Tag } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { HiSparkles } from 'react-icons/hi';
import { NavLink } from 'react-router-dom';

import { companySettingsData } from 'containers/CompanySettings/CompanySettingsData';
import { useFeatureStore } from 'store/useFeatureStore';
import { useUserStore } from 'store/useUserStore';

const VerticalSettingsTabs: React.FC<unknown> = () => {
  const { t } = useTranslation(['common']);

  const featureList = useFeatureStore(state => state.features);
  const companyInfo = useUserStore((state: any) => state.user?.companyInfo || {});

  return (
    <Box borderRightWidth={{ base: 'none', lg: '1px' }} borderColor="primary.100" overflow="auto">
      <Stack direction={{ base: 'row', lg: 'column' }} spacing="16px" width="100%" pb="3">
        {companySettingsData(featureList, companyInfo).map((setting: any) => {
          if (!setting?.isVisible) return null;

          return (
            <Box
              as={NavLink}
              to={setting.path}
              display="block"
              color="gray.500"
              key={setting.label}
              sx={{
                '&.active': {
                  color: 'primary.500',
                  fontWeight: '600',
                  cursor: 'pointer',
                  pb: 1,
                  borderBottom: '1.5px solid',
                  borderColor: 'primary.500',
                },
              }}
              p={{ base: '2', lg: '0' }}
              whiteSpace={{ base: 'nowrap', lg: 'normal' }}
              w="fit-content"
              position="relative"
            >
              <Box display="flex" flexDir="column">
                {setting.label}
                {setting.isBeta ? (
                  <Tag
                    colorScheme="secondary"
                    color="secondary.700"
                    fontWeight="bold"
                    w="fit-content"
                    mt={1}
                    display="flex"
                    gridGap={1}
                    alignItems="center"
                  >
                    {t('common:beta')}
                    <HiSparkles />
                  </Tag>
                ) : null}
                {setting.isNew ? (
                  <Tag
                    background="secondary.700"
                    color="white"
                    w="fit-content"
                    display="flex"
                    alignItems="center"
                    position="absolute"
                    left="calc(100% + 4px)"
                    bottom="40%"
                    size="xs"
                    fontSize="9px"
                    p="1"
                    py="0.5"
                    borderRadius="lg"
                    textTransform="uppercase"
                    fontWeight="normal"
                  >
                    {t('common:new')}
                  </Tag>
                ) : null}
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
};
export default VerticalSettingsTabs;
